package com.ives.utils;

import com.ives.components.viewer.DicomViewer;
import js.html.SpanElement;
import com.ives.utils.Translator;
import js.html.LabelElement;
import js.html.DivElement;
import js.html.Element;
import js.html.NodeList;
import js.Browser;

class ButtonGroup {
	private static inline var GROUP_ATTR:String = "data-group";
	private static inline var ID_ATTR:String = "id";
	private static inline var NAME_ATTR:String = "name";
	private static inline var VALUE_ATTR:String = "value";
	private static inline var TYPE_ATTR:String = "type";
	private static inline var RADIO:String = "radio";
	private static inline var INPUT:String = "input";
	private static inline var LABEL:String = "label";

	public static function init(){
		var groups:NodeList = Browser.document.querySelectorAll('*[${GROUP_ATTR}]');

		for(group in groups){
			var element:Element = cast group;

			// if already created - ignore
			if(element.querySelector(LABEL) != null)
				continue;

			var name:String = element.getAttribute(GROUP_ATTR);

			for(child in element.children){
				if(child.nodeName.toLowerCase() != INPUT)
					continue;

				var id:String = child.getAttribute(ID_ATTR);

				if(child.getAttribute("data-type") == "button"){
					Log.debug("Just a simple button");

					id = null;
				}

				child.setAttribute(NAME_ATTR, name);
				child.setAttribute(VALUE_ATTR, id);
				child.setAttribute(TYPE_ATTR, RADIO);

				var label:LabelElement = Browser.document.createLabelElement();

				label.htmlFor = id;

				if(child.hasAttribute(Translator.TR_ATTR)){
					var translation:String = child.getAttribute(Translator.TR_ATTR);

					child.removeAttribute(Translator.TR_ATTR);

					var titleTranslation:String = translation;

					if(child.hasAttribute(Translator.TR_TITLE_ATTR))
						titleTranslation = child.getAttribute(Translator.TR_TITLE_ATTR);

					label.setAttribute(Translator.TR_TITLE_ATTR, titleTranslation);
					label.className = child.className;

					var div:DivElement = Browser.document.createDivElement();
					div.className = child.className + " bg";
					label.appendChild(div);

					var span:SpanElement = Browser.document.createSpanElement();
					span.setAttribute(Translator.TR_ATTR, translation);
					label.appendChild(span);
				}

				if(child.hasAttribute(DicomViewer.EVENT_ATTR)){
					var event:String = child.getAttribute(DicomViewer.EVENT_ATTR);

					child.removeAttribute(DicomViewer.EVENT_ATTR);

					label.setAttribute(DicomViewer.EVENT_ATTR, event);
				}

				if(child.hasAttribute(DicomViewer.SYNC_ATTR)){
					var sync:String = child.getAttribute(DicomViewer.SYNC_ATTR);

					child.removeAttribute(DicomViewer.SYNC_ATTR);

					label.setAttribute(DicomViewer.SYNC_ATTR, sync);
				}

				insertAfter(label, child);
			}
		}
	}

	private static function insertAfter(newNode:Element, referenceNode:Element){
		referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
	}
}
